import { call, put, select } from "redux-saga/effects";
import { notify } from "../../../services/notification";
import api, { makeOptions } from "../../../services/api";
import ActionsSapDelete from "../../ducks/sap/delete";

const getAuthData = (state) => state.auth.data;

export function* destroy(action) {
  try {
    const { params, onSuccess } = action;

    const url = `bom-sap/${params}`;
    const authData = yield select(getAuthData);
    const { data } = yield call(api.delete, url, makeOptions(authData));

    yield put(ActionsSapDelete.success(data.data));
    notify("success", "Arquivo deletado com sucesso!");
    onSuccess();
  } catch (err) {
    notify("error", err.response.data.error.message);
    yield put(ActionsSapDelete.failure(err.response.data.error.message));
  }
}
